import { cn } from '@/lib/utils'
import { memo } from 'react'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-neutral-200', className)}
      {...props}
    />
  )
}

export default memo(Skeleton)
